import React, { useState, useEffect } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { Link } from "react-router-dom";

import PartyAddAddress from "../address/Party-Add-Address";
import Partycontact from "../contact/Party-contact";
import AddNotification from "../notifications/AddNotification";
import PartyAdd from "./Party-Add";
import { getTrans as t } from "../../../../Localization/translations";
import PartyShortdetilview from "./partyquickview";
import AddAchAccounts from "../achAccount/achAdd";


function AddnewPartyIndex() {
  const [tabIndex, setTabIndex] = useState(0);
  const [partyId, setPartyId] = useState(0);
  const [addressId, setAddressId] = useState(null);
  const [contactId, setContactId] = useState(null);
  const [achId, setACHId] = useState(null);
  const [contactemail, setContactEmail] = useState(null);
  const [notificationId, setnotificationId] = useState(null);
  const [partytype, setPartyType] = useState('');
  const isMobile = window.innerWidth <= 768;
  const handleClick = (index) => {
    setTabIndex(index);
  };
  const [hideShowachindex, setHideShowAchIndex] = useState(false);

  useEffect(() => {
    if (window.innerWidth <= 768) {
      setTabIndex(0);
    }
  }, []);


  return (
    <>
      <div className="container-fluid py-4">
        <div className="row">
          <div className="col-md-2">
            <div className="header pb-0 mb-3">
              <h5>{t("Add New Party")}</h5>
              <h6>
                <Link to="/party" className="tc">
                  {t("Parties")}
                </Link>{" "}
                / <span> {t("New party")} </span>
              </h6>
            </div>
          </div>
        </div>
        <div className="form-group row">
          <Tabs
            selectedIndex={tabIndex}
            onSelect={(index) => handleClick(index)}
          >
            {!isMobile && (
              <TabList>
                <Tab>
                  <p>{t("Party Detail")}</p>
                </Tab>
                <Tab disabled={partyId !== 0 ? false : true}>
                  <p>{t("Address Details")}</p>
                </Tab>
                <Tab disabled={partyId !== 0 ? false : true}>
                  <p>{t("Contact Details")}</p>
                </Tab>
                {
                  partytype.includes('Customer') ?

                    <Tab disabled={partyId !== 0 ? false : true}>
                      {/* <Tab > */}
                      <p>{t("Bank Accounts")}</p>
                    </Tab>
                    : ""
                }
                {
                  partytype.includes('Customer') ?

                    <Tab disabled={partyId !== 0 ? false : true}>
                      <p>{t("Notification Settings")}</p>
                    </Tab> : ''
                }
              </TabList>
            )}
            <TabPanel>
              <div className="panel-content">
                <PartyAdd
                  setPartyId={setPartyId}
                  id={partyId}
                  setAddressId={setAddressId}
                  address={addressId}
                  setTab={setTabIndex}
                  partyType={setPartyType}
                />
              </div>
            </TabPanel>
            <TabPanel>
              <div className="panel-content">
                <div className="container-fluid mb-2">
                  <PartyShortdetilview id={partyId} setTab={setTabIndex} />
                </div>
                <PartyAddAddress
                  id={partyId}
                  setAddressId={setAddressId}
                  address={addressId}
                  setTab={setTabIndex}
                />
              </div>
            </TabPanel>
            <TabPanel>
              <div className="panel-content">
                <div className="container-fluid mb-2">
                  <PartyShortdetilview id={partyId} setTab={setTabIndex} />
                </div>
                <Partycontact
                  id={partyId}
                  setContactId={setContactId}
                  setContactEmail={setContactEmail}
                  contact={contactId}
                  setTab={setTabIndex}
                  partyType={partytype}
                />
              </div>
            </TabPanel>
            <TabPanel>
              <div className="panel-content">
                <div className="container-fluid mb-2">
                  <PartyShortdetilview id={partyId} setTab={setTabIndex} />
                </div>
                <AddAchAccounts
                  id={partyId}
                  setACHId={setACHId}
                  achid={achId}
                  setHideShowAchIndex={setHideShowAchIndex}
                  setTab={setTabIndex}
                  partyType={partytype}

                />
              </div>
            </TabPanel>
            <TabPanel>
              <div className="panel-content">
                <div className="container-fluid mb-2">
                  <PartyShortdetilview id={partyId} setTab={setTabIndex} />
                </div>
                <AddNotification
                  id={partyId}
                  setnotificationId={setnotificationId}
                  contactemail={contactemail}
                  notification={notificationId}
                  setTab={setTabIndex}
                />
              </div>
            </TabPanel>
          </Tabs>
        </div>
      </div>
    </>
  );
}

export default AddnewPartyIndex;
